export default {
  strict: true,
  namespaced: true,
  state: {
    logs: {
      list: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      since: null,
      until: null,
      reachMax: false
    }
  },
  mutations: {
    addLogs (state, value) { state.logs.list.push(value) },
    setLogsField (state, data) {
      state.logs[data.field] = data.value
      for (let field in data.fields) {
        state.logs[field] = data.fields[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/consumer/logs.js